import fulfillmentType from './fulfillment-type';
import orderNumber from './order-number';
import deliveryStatus from './delivery-status';
import trackingNumber from './tracking-number';
import batchNumber from './batch-number';
import recipient from './recipient';
import carrier from './carrier';
import country from './country';
import shipFrom from './ship-from';
import shipDate from './ship-date';
import submissionDate from './submission-date';
import createdDate from './created-date';
import notes from './notes';
import createdBy from './created-by';
import rmaNumber from './rma-number';
import returningParty from './returning-party';
import returnReceived from './return-received';

import { shipments, fulfillments, batches, returns } from '../../../filters/options/fulfillment-type/options';

const fulfillmentTypeFiltersMap = {
  [shipments.id]: [
    fulfillmentType,
    trackingNumber,
    deliveryStatus,
    orderNumber,
    batchNumber,
    recipient,
    carrier,
    country,
    shipFrom,
    shipDate,
  ],
  [fulfillments.id]: [
    fulfillmentType,
    trackingNumber,
    deliveryStatus,
    orderNumber,
    batchNumber,
    recipient,
    // carrier, // not supported at this time
    country,
    submissionDate,
    shipDate,
  ],
  [batches.id]: [fulfillmentType, batchNumber, createdBy, shipFrom, shipDate, createdDate, notes],
  [returns.id]: [fulfillmentType, trackingNumber, orderNumber, rmaNumber, returningParty, carrier, country, returnReceived],
};

export default (fulfillmentTypeId) => {
  return fulfillmentTypeFiltersMap[fulfillmentTypeId] || [fulfillmentType];
};
